<template>
  <div class="teacher-work-box flex-column-between teacher-work-bg">
    <div>
      <header class="teacher-head flex-between" style="padding-bottom:0;align-items: start">
        <div class="flex-align-center back-box">
          <span class="class-text">{{ className || '班级名称' }}</span>
        </div>
        <div class="flex-align right-button" style="align-items: start">
          <div class="flex-column-center small-code pointer" @click="openPreview">
            <vue-qr :text="qrText" :size="84" :logoScale="0.3" :margin="3" />
            <span class="text">点击放大</span>
          </div>
          <div class="flex-align-center back-box" @click="goBack">
            <img alt="" class="back-ico" src="@/assets/teacher/back-ico.png">
            <span class="back-text">返回</span>
          </div>
        </div>
      </header>
      <div class="student-status flex-align">
        <div class="flex-align-center item">
          <img alt="" class="img" src="@/assets/teacher/stauts-1.png">
          <span class="text">未登录</span>
        </div>
        <div class="flex-align-center item selected">
          <img alt="" class="img" src="@/assets/teacher/stauts-2.png">
          <span class="text">已登录</span>
        </div>
      </div>
    </div>
    <div class="content-box flex-1">
      <div class="student-list-container">
        <div class="student-grid">
          <div v-for="(student, index) in classInList" :key="student.id || index" class="student-item" :class="{'default': student.type == '0','selected': student.type == '1',}">
            <div class="student-name">{{ student.studentName || student.name || '—' }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 确定按钮 -->
    <footer class="footer-bottom confirm-section">
      <button class="confirm-btn" :disabled="!hasLoggedInStudent" @click="confirmTest">
        {{ hasLoggedInStudent ? '开始测试' : '等待学生登录' }}
      </button>
    </footer>
    <div v-if="previewVisible" class="image-preview-mask" @click="closePreview">
      <div class="image-preview-img" @click.stop>
        <div class="image-preview-code">
          <img alt="" class="bg" src="@/assets/teacher/code-bg.png">
          <div class="code">
            <vue-qr :text="qrText" :size="460" :logoScale="0.3" :margin="6" />
          </div>
        </div>
      </div>
      <img class="image-preview-close" @click.stop="closePreview"
        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADsAAAA7CAMAAADy+wKBAAAAAXNSR0IArs4c6QAAAaFQTFRFAAAA////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////ja4xQQAAAIp0Uk5TAAEEBQYHCAkKDA0ODxESExcYGRscICIjJCYnKCkvMDIzNzg5Pj9CQ0ZHSElKS09RUlNVVldYWl1fYGFiY2RmamtsbW5vcHN0dXZ4h4iJiouQkZOUlZaXmZqdpKWrrq+wsbK3uM3O0dLV1tfY2drb3N3e3+Dh4+Tl5ufo6err7O3w8fLz9ff5+vv+T4e8owAAAz5JREFUSMedl2tDUkEQhqew1DIzK7Uou6CVlUmUXaWMTLtQmWWSZXeNoARBKi8USFE8v7oPB3IP7HoOzSfPzjysuzsz+66I1g5cGX8by/7hTzb2dvzKAXFtvskMdstM+tyAjaF5dDYfanIgG0ZXMNnKaMNG6LFYJbAUnwmHLgYuhsIz8VJlMHbcSG6ZKMcUpgfblPG2welC2TOxRY92vLf8qeHmGl/z9ZTlnO3Uod1LAGSDHu0ve4JZAJa6a309eQAiO4xL2hEBIN9T7TiYA8gHNjyFQB4gVzVz1ypAwutwhN4EwGqXOtY0BxBtd8yc9ijAnJomUwCZPS7Sbk8GYGp94ARA3l3Ge3MAfZXPrUmAcy4r5RzAwtby122AiOsyiwCMlStnBVhqcc22LAHLjSIiMgIw5L68ZQhgRERE5oG0pw7WkwY+i4j4AG6ovpPpxGl79OlE+pTyOQzgE5FJoLBNjUxDcUAd8BchrVZVAZgUkQzw3DZLEjvsLwIJNWIayIjsB7CXQH8RKPptaLFfjRgE8MpVoNRqX95ZFbbQs7aAthJwVR4BseqdVGAdKhIHxuUd8EqMsB6Vl8A7iQNhMcEGVMJATLLALU0CWJQBlVvAV/ltSkh/0eqMOlSGgDUBuCBmeP2sVLsAYJ5XBix2QIzzZv/VhBY1wNZ6DftsodZeaeAwEDWcbxktn1Htkl8Cr+UR8MlwQn7lj9q8emDl804TaoDbSsAl8QKcN6J6eBBgr8gX4EWdNTgNpMp945etSyacar+5ADyp9KtQXT1nGKBXRDbNA4nNiuvUYrLfvgH9yUWl13lSQGKTiMgYQLDe/mzVXsuP/7gXvpc1yd2qa9HBpgDuVO7BBaB0xiUaAEhW7kHpA8i5u3/32e9fkSd13vuPVUU3CxDd7YjuigLM2tRd5ypA2knn7NPoHJFDOYCcG33180j1eO8aAM9anXTdWm+t6/CypSevmfTkKgDLh3Xezg9Wc1u8ud2sYz906P+ppkhFPz8/v1Ovn6fMwv94XNHt90eCgeDIPUW3L/Rt+F4Y2+i90OhwhE2Gd8rn4UY3Ket7mqp+H00cdV/eHZcfvvn4Nc/at4+vHl7arw/6C7dGBBwGfhvqAAAAAElFTkSuQmCC">
    </div>
  </div>
</template>

<script>
import vueQr from 'vue-qr';
export default {
  data() {
    return {
      writeCount: null,
      classId: '',
      testId: '',
      className: '',
      loadingList: false,
      classInList: [],
      selectedStudent: null,
      previewVisible: false,
      qrText: '',
      refreshTimer: null, // 定时器
      hasLoggedInStudent: false, // 是否有学生已登录
    };
  },
  components: { vueQr },
  //方法
  methods: {
    goBack() {
      if (this.$router && typeof this.$router.back === 'function') {
        this.$router.back();
      } else {
        window.history.back();
      }
    },
    async loadClassInList() {
      try {
        this.loadingList = true;
        const params = {
          classId: this.classId,
          testId: this.testId,
        };
        const res = await this.$Api.CopyBook.queryClassInList(params);
        if (res && res.code === 200 && Array.isArray(res.data)) {
          this.classInList = res.data;
          this.hasLoggedInStudent = res.data.some(item => item.type === 1);

        } else {
          this.classInList = [];
          this.hasLoggedInStudent = false;
          if (this.$message) {
            this.$message.error((res && (res.msg || res.message)) || '获取测评列表失败');
          }
        }
      } catch (e) {
        this.classInList = [];
        this.hasLoggedInStudent = false;
        if (this.$message) {
          this.$message.error('获取测评列表失败');
        }
      } finally {
        this.loadingList = false;
      }
    },
    async confirmTest() {
      // 成功后跳转到classRoster页面，传递classId和testId
      let resData = await this.$Api.CopyBook.classTestStart(`testId=${this.testId}`)
      console.log('教师端开始测评:', resData);
      this.$router.push({
        name: 'classTest',
        query: {
          classId: this.classId,
          testId: this.testId,
        }
      });
    },
    openPreview() {
      this.buildQrText();
      this.previewVisible = true;
    },
    closePreview() {
      this.previewVisible = false;
    },
    buildQrText() {
      const teacherId = sessionStorage.getItem('teacherId') || '';
      const hashPath = 'https://yun.cnuzi.com/student/classMates'; // 正式
      // const hashPath = 'https://ssyzpccdn.lezhireading.com/student/classMates'; // 测试
      const params = `classId=${encodeURIComponent(this.classId || '')}&testId=${encodeURIComponent(this.testId || '')}&teacherId=${encodeURIComponent(teacherId || '')}&t=${Date.now()}`;
      this.qrText = `${hashPath}?${params}`;
      console.log(this.qrText);
    },
    // 开始定时刷新
    startRefreshTimer() {
      // 清除已存在的定时器
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer);
      }
      // 每3秒刷新一次学生列表
      this.refreshTimer = setInterval(() => {
        this.loadClassInList();
      }, 3000);
    },
    // 停止定时刷新
    stopRefreshTimer() {
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer);
        this.refreshTimer = null;
      }
    }
  },
  created() {
    this.classId = (this.$route && this.$route.query && this.$route.query.classId) || '';
    this.testId = (this.$route && this.$route.query && this.$route.query.testId) || '';
    // 从 sessionStorage 获取班级名称
    const classDataStr = sessionStorage.getItem('selectedClassData');
    if (classDataStr) {
      const classData = JSON.parse(classDataStr);
      this.className = classData.className || '';
    } else {
      this.className = '';
    }

  },
  mounted() {
    if (this.classId) {
      this.loadClassInList();
      // 启动定时刷新
      this.startRefreshTimer();
    } else if (this.$message) {
      this.$message.warning('缺少班级参数');
    }
    this.buildQrText();
  },
  beforeDestroy() {
    // 清理定时器
    this.stopRefreshTimer();
  },
};
</script>
<style lang='less' scoped>
@import "./less/classTestMain.less";
</style>
